import { em } from 'polished'
import styled, { css } from 'styled-components'

import FrameMacStraight from 'components/FrameMacStraight'

export const Cover = styled.div`
  position: absolute;
  right: 0;
  height: 100%;
  background: ${p => p.theme.colors.mineShaft};
  display: ${p => (p.isTablet ? 'none' : 'block')};
  ${p =>
    p.isTablet
      ? css`
          width: 59%;
        `
      : css`
          width: 90%;
        `}

  ${p => p.theme.mq.upMd} {
    right: auto;
    display: ${p => (p.isTablet ? 'block' : 'none')};
  }

  ${p => p.theme.mq.upLg} {
    width: 60%;
  }
`

export const Content = styled.div`
  min-height: 0;
  display: flex;
  align-items: center;

  ${p => p.theme.mq.upMd} {
    min-height: ${p => p.theme.blocks.heightMinResultsMd};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${p => p.theme.blocks.heightMinResultsLg};
  }
`

export const FrameWrapper = styled.div`
  position: relative;
  min-height: ${p => p.theme.blocks.heightMinResults};
`

export const FrameMacStraightStyled = styled(FrameMacStraight)`
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    margin: 0;
    left: -${em(265)};
  }

  ${p => p.theme.mq.upLg} {
    left: auto;
    margin-top: ${em(70)};
  }
`

export const IconWrapper = styled.div`
  position: absolute;
  z-index: 4;
  backface-visibility: hidden;

  &.hh-thin {
    width: ${em(120)};
    height: ${em(120)};
    top: 0;
    right: 0;
    transform: translate(0, -70%);

    ${p => p.theme.mq.upMd} {
      right: 50%;
      transform: translate(315%, -17%) rotate(0);
    }

    ${p => p.theme.mq.upLg} {
      width: ${em(150)};
      height: ${em(150)};
      right: 0;
      transform: translate(22%, -90%);
    }
  }
`

export const HeaderWrapper = styled.div`
  ${p => p.theme.mq.upLg} {
    max-width: ${em(460)};
  }
`
